<template>
  <div class="times">
    <div
      v-for="(item, index) of times"
      :key="index"
      class="cell"
      :class="getClasses(item)"
      @click="onChoose(item)"
    >
      <div class="time">
        <span class="hour">{{ item.text.split(':')[0] }}</span>
        <span class="minute">{{ item.text.split(':')[1] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeDropdown',
  props: {
    active: {},
    times: {
      type: Array,
      default: () => []
    }
  },
  emits: ['choose'],
  methods: {
    getClasses (cellData) {
      return {
        cell_disabled: cellData.disabled,
        cell_active: cellData.active
      }
    },
    onChoose (cellData) {
      this.$emit('choose', cellData)
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                 #FF7A00 !default;

.times {
  display: inline-flex;
  flex-wrap: wrap;

  .cell {
    height: 42px;
    width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #FFFFFF;
    font-weight: 700;
    user-select: none;
    transition: .1s;

    &_disabled {
      color: #868686;
      cursor: default;
      pointer-events: none;
    }

    &_active {
      background: $brand-color;
    }

    .time {
      display: inline-flex;

      .hour {
        font-size: 18px;
      }

      .minute {
        font-size: 10px;
        padding-left: 3px;
      }
    }
  }
}
</style>
